import React, {useEffect, useContext} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  let currencyOptions = []
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['NumericField', 'CurrencyField'], false, false, false)
  }, [group_id, getAdditionalFieldValues])
  let mathOperatorOptions = ['+', '-', '*', '/']
  return (
    <>
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_negative', !(data?.allow_negative || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_negative || false}
            name="required"
          />
        }
        label="Allow negative"
      />
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Calculation Options</InputLabel>
        <Select
          labelId=""
          id=""
          label="Calculation Options"
          value={data}
          onChange={onChange}
          style={{width: '200px'}}
        >
          {additionalFieldValues.data.data?.fields.map(opt => {
            return <MenuItem value={opt.name}>{`${opt.name} `}</MenuItem>
          })}
        </Select>
      </FormControl>{' '}
      ={' '}
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <Select labelId="" id="" value={data} onChange={onChange} style={{width: '200px'}}>
          {additionalFieldValues.data.data?.fields.map(opt => {
            return <MenuItem value={opt}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <Select labelId="" id="" value={data} onChange={onChange} style={{width: '200px'}}>
          {mathOperatorOptions.map(opt => {
            return <MenuItem value={opt}>{`${opt}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <Select labelId="" id="" value={data} onChange={onChange} style={{width: '200px'}}>
          {additionalFieldValues.data.data?.fields.map(opt => {
            return <MenuItem value={opt.name}>{`${opt.name} `}</MenuItem>
          })}
        </Select>
      </FormControl>
    </>
  )
}

export default FTextField
